import { Directive, ElementRef, HostBinding, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[egDropdown]',
  exportAs: 'egDropdown',
  standalone: false,
})
export class DropdownDirective {
  private elementRef = inject(ElementRef);

  @HostBinding('class.open') isOpen = false;

  @HostListener('click', ['$event'])
  toggleOpen(event: MouseEvent) {
    this.isOpen = !this.isOpen;
    event.stopPropagation();
  }

  @HostListener('document:click', ['$event'])
  closeOutside(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
